import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcChevronDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("path", { d: "M0 0h24v24H0z" }), /* @__PURE__ */ _jsx("path", {
			fill: "#999",
			fillRule: "nonzero",
			d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z"
		})]
	})
});
export default SvgIcChevronDown;
